
import React from "react";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import AccountSidebar from "../../components/general/orderHistory/accountSidebar";
import {getRouteUrl} from "../../helpers/routing/getRouteUrl";
import {
    ROUTE_ADDRESSES,
    ROUTE_COUPONS,
    ROUTE_DETAILS,
    ROUTE_ORDER_HISTORY, ROUTE_RETURNS
} from "../../routers/routes";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {DASHBOARD} from "../../locales/components/namespaces";
import {useDispatch} from "react-redux";
import {userLogout} from "../../actions/currentUser/actions";


export default function Returns() {
    const history = useHistory()
    const { t } = useTranslation(DASHBOARD);
    const dispatch = useDispatch();

    const accountMenuItems = [
        t("accountDetails"),
        t( "orderHistory"),
        t("addresses"),
        t("logout"),
    ];

    const handleLogout = () => {
        dispatch(userLogout());
        history.push(`/`)
    };

    return (
        <Box
            sx={{
                width: "95%",
                maxWidth: 1760,
                mx: "auto",
                bgcolor: "#E9E9E9",
                borderRadius: "30px",
                px: { xs: 2, md: 6 },
                py: { xs: 4, md: 6 },
            }}
        >
            <Box
                sx={{
                    maxWidth: 1335,
                    mx: "auto",
                    //bgcolor: "#E9E9E9",
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "'Zen Maru Gothic', sans-serif",
                        fontWeight: 900,
                        fontSize: { xs: 24, md: 36 },
                        lineHeight: "110%",
                        textAlign: "left",
                        textTransform: "uppercase",
                        mb: { xs: 3, md: 5 },
                        color: "#111111",
                    }}
                >
                    {t('Returns')}
                </Typography>

                <Grid container spacing={{ xs: 3, md: 4 }}>
                    <Grid item xs={12} md={3}>
                        <AccountSidebar
                            items={accountMenuItems}
                            activeIndex={2}
                            onSelect={(index) => {
                                if (index === 0) history.push(getRouteUrl(ROUTE_DETAILS));
                                if (index === 1) history.push(getRouteUrl(ROUTE_ORDER_HISTORY));
                                if (index === 2) history.push(getRouteUrl(ROUTE_ADDRESSES));
                                if (index === 3) handleLogout();
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={9}>

                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
